import React from 'react';

import { Switch as MuiSwitch, switchClasses, SwitchProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { SwitchProps };

export const Switch: React.ComponentType<SwitchProps> = styled((props: SwitchProps) => (
  <MuiSwitch disableRipple {...props} />
))(({ theme, color }) => ({
  width: 48,
  height: 32,
  padding: 0,
  '&:hover': {
    [`& .${switchClasses.switchBase}:not(.${switchClasses.checked}) + .${switchClasses.track}`]: {
      backgroundColor:
        color === 'primary'
          ? theme.palette.colors['bg-active']['neutral-secondary-hard']
          : undefined,
    },
    [`& .${switchClasses.switchBase}.${switchClasses.checked} + .${switchClasses.track}`]: {
      backgroundColor:
        color === 'primary' ? theme.palette.colors['bg-active']['action-primary'] : undefined,
    },
  },
  [`& .${switchClasses.switchBase}`]: {
    padding: 0,
    margin: 4,
    transitionDuration: '300ms',
    [`&.${switchClasses.checked}`]: {
      transform: 'translateX(16px)',
      color: '#fff',
      [`& + .${switchClasses.track}`]: {
        ...(color === 'primary' && {
          backgroundColor: theme.palette.colors.bg['action-primary'],
        }),
        ...(color === 'danger' && { backgroundColor: theme.palette.colors.bg['danger-primary'] }),
        opacity: 1,
        border: 0,
      },
      [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
        opacity: 0.5,
      },
    },
    [`&.Mui-focusVisible .${switchClasses.thumb}`]: {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    [`&.${switchClasses.disabled} .${switchClasses.thumb}`]: {
      color: theme.palette.colors.special.bg.disabled,
    },
    [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
      backgroundColor: theme.palette.colors.special.bg.disabled,
      opacity: 1,
    },
  },
  [`& .${switchClasses.thumb}`]: {
    boxShadow:
      '0px 0px 8px rgba(26, 27, 35, 0.24),0px 0px 8px rgba(26, 27, 35, 0.06),0px 0px 1px rgba(26, 27, 35, 0.04)',
    backgroundColor: theme.palette.colors.static.content['key-light'],
    boxSizing: 'border-box',
    width: 24,
    height: 24,
    borderRadius: '50%',
  },
  [`& .${switchClasses.track}`]: {
    borderRadius: 32,
    ...(color === 'primary' && {
      backgroundColor: theme.palette.colors.bg['neutral-secondary-hard'],
    }),
    ...(color === 'danger' && {
      backgroundColor: theme.palette.colors['bg-active']['danger-secondary'],
    }),
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
